import { ForwardedRef, forwardRef, useEffect, useImperativeHandle, useState } from 'react'
import { IDigitalAddress, IEmailInput } from '../../../../types/contact';
import { Form, FormFeedback, FormGroup, Input } from 'reactstrap';
import { validEmail } from '../../../../utils/commons';
import Info from '../../../common/info';

export type EmailHandler = {
    getEmail: () => IEmailInput;
    validate: (inclMandatoryCheck: boolean) => boolean;
}

type EmailDetailsProps = {
    digitalAddress?: IDigitalAddress;
    isRole: boolean;
    onChange: () => void;
    autoFocus?: boolean;
}

const EmailDetails = forwardRef<EmailHandler, EmailDetailsProps>((props: EmailDetailsProps, ref:ForwardedRef<any>) => {
    const  {digitalAddress, isRole, onChange, autoFocus} = props

    const [emailInput, setEmailInput] = useState<IEmailInput>()
    const [addressError, setAddressError] = useState('')
    const [inlineVaidate, setInlineValidate] = useState<boolean>(false)

    useEffect(() => {
        setEmailInput({
            digitalAddressId: digitalAddress?.id || 0,
            address: digitalAddress?.emailAddressTxt || ''
        })
    }, [digitalAddress])

    useEffect(() => {
        onChange()
    }, [emailInput])

    useImperativeHandle(ref, () => ({
        getEmail(): IEmailInput {
            return emailInput!
        },
        validate(inclMandatoryCheck: boolean): boolean {
            let isValid: boolean = !addressError
            if (isValid && inclMandatoryCheck) {
                setInlineValidate(true)
                if (!emailInput?.address) {
                    setAddressError('Email address is required.')
                    isValid = false
                } else if (!validEmail(emailInput?.address)) {
                    setAddressError("The email address is invalid.")
                    return false
                } 
            }
        
            return isValid
        }
    }), [emailInput])

    const changeAddress = (event: any) => {
        validateAddress(event.target.value.trim())
        setEmailInput({...emailInput, address: event.target.value.trim()})
    }

    const validateAddress = (address: string): boolean => {
        if (!address || validEmail(address) && address.length <= 100) {
            setAddressError('')
        } else if (inlineVaidate && !validEmail(address)) {
            setAddressError("The email address is invalid.")
            return false
        }
    
        if (address.length > 100) {
            setAddressError("This value is too long. It should have 100 characters or fewer.")
            return false
        } 
        return true
    }

    return (
        <Form>
            <FormGroup>
                <div className='row'>
                    <div className='col-md-12'>
                        <Info color='warning'>This email address will override the individual's email address for the selected {isRole ? 'role' : 'position'} in INFO-GO.</Info>
                    </div>
                    <div className='col-md-4'><label htmlFor="digitalAddress">Email Address: (required)</label></div>
                    <div className='col-md-8'>
                        <Input id="digitalAddress" 
                            type="text" 
                            style={{width: '100%'}} 
                            value={emailInput?.address} 
                            onChange={changeAddress} 
                            placeholder='Enter an address'
                            invalid={!!addressError}
                            required
                            autoFocus={autoFocus}
                        />
                        <FormFeedback>{addressError}</FormFeedback>
                    </div>
                </div>
            </FormGroup>
        </Form>
    )
})

export default EmailDetails